import React, { Component } from 'react';
import cx from 'classnames';
import $ from 'jquery';
import tracking from '../../utils/tracking';
import TextInput from '../../components/elements/TextInput';

export default class Kontaktdaten extends Component {
    constructor(props){
        super(props);
        this.state = {};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onChange(obj){
        this.setState(obj);
    }

    handleSubmit(e){
        e.preventDefault();
        if (!$.isEmptyObject(this.state)) {
            tracking.event('kontaktdaten', 'submit', 'success');
            this.props.contact(this.state);
            this.props.onNext();
        }else{
            tracking.event('kontaktdaten', 'submit', 'else');
        }
    }

    render() {

        let classes = cx('kontaktdaten', 'content',{'hidden': !this.props.active});

        return (
            <div>
                <section className={classes}>
                    <form onSubmit={this.handleSubmit}>
                        <TextInput
                            required
                            type="email"
                            shorName="email"
                            name="Email"
                            placeholder=""
                            helpertext=""
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="text"
                            shorName="name"
                            name="Nom"
                            placeholder=""
                            helpertext=""
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="text"
                            shorName="surname"
                            name="Prénom"
                            placeholder=""
                            helpertext=""
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="text"
                            shorName="address"
                            name="Adresse"
                            placeholder=""
                            helpertext=""
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="text"
                            shorName="zip"
                            name="Code postal"
                            placeholder="example: L-3873"
                            helpertext=""
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="text"
                            shorName="city"
                            name="Ville"
                            placeholder=""
                            helpertext=""
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="number"
                            shorName="phone"
                            name="Téléphone"
                            placeholder="example: 00352 12 34 56"
                            helpertext="Veuillez utiliser seulement des numériques"
                            onChange={this.onChange} />
                        <TextInput
                            required
                            type="number"
                            shorName="svn"
                            name="Matricule"
                            placeholder=""
                            helpertext="Le numéro d’identification est sur 13 positions et se compose de 11 numériques identifiants et de 2 numériques de contrôle : AAAAMMJJXXXC1C2"
                            onChange={this.onChange} />
                        <button className="btn btn-default" onClick={this.props.onPrev}>Retour</button>
                        <button type="submit" className="btn btn-default pull-right">Suivant</button>
                        <div className="clearfix"></div>
                    </form>
                </section>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/module/kontaktdaten/index.js